export const LOADING_CHUNK_MESSAGE_CHROME = 'failed to fetch dynamically imported module';
export const LOADING_CHUNK_MESSAGE_SAFARI = 'importing a module script failed';
export const LOADING_CHUNK_MESSAGE_FIREFOX = 'error loading dynamically imported module';

export const LOADING_CHUNK_MESSAGES = [
  LOADING_CHUNK_MESSAGE_CHROME,
  LOADING_CHUNK_MESSAGE_SAFARI,
  LOADING_CHUNK_MESSAGE_FIREFOX
];
